import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { LogMessageType } from '../../../enums/LogMessageType';

export class SendLogMessageService extends HttpServiceBase {

  handle = (input: SendLogMessageInput): Promise<Result<SendLogMessageOutput> | null> => {
    const promise = this.http.post<Result<SendLogMessageOutput>, SendLogMessageInput>(
        `${this.baseUrlSislogApi}/point-of-sale/log-message?apiKey=${this.getSislogApiKey()}`,
        input);
    return promise;
  }
}

export class SendLogMessageInput {
  messageType: LogMessageType;
  message: string;
}

export class SendLogMessageOutput {
  result?: boolean;
}